import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { Card } from '@/components/ui/card';
import { ShieldCheck, RefreshCw } from 'lucide-react';

export function ApprovalNode({ data, selected }: any) {
  const isRefine = data?.max_rounds !== undefined || data?.action === 'approval-refine-rca';
  const Icon = isRefine ? RefreshCw : ShieldCheck;
  return (
    <div className="relative">
      <Handle type="target" position={Position.Left} className="!bg-primary !w-2 !h-2" />
      <Handle type="source" position={Position.Right} id="approved" style={{ top: '30%' }} className="!bg-green-500 !w-2 !h-2" />
      <Handle type="source" position={Position.Right} id="rejected" style={{ top: '70%' }} className="!bg-red-500 !w-2 !h-2" />
      <Card
        className={`w-[260px] p-3 border-2 transition-shadow cursor-pointer ${
          selected ? 'border-primary shadow-lg ring-2 ring-primary/20' : 'border-zinc-300 dark:border-zinc-700'
        } bg-zinc-50 dark:bg-zinc-900/40`}
      >
        <div className="flex items-center gap-2 mb-2">
          <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-zinc-100 dark:bg-zinc-800">
            <Icon className="w-4 h-4 text-zinc-500 dark:text-zinc-400" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-xs font-medium text-zinc-500 dark:text-zinc-400 uppercase tracking-wide">
              {isRefine ? 'Refine + Approve' : 'Approval'}
            </div>
            <div className="text-sm font-semibold truncate">{data.label || (isRefine ? 'Refine RCA / Approve' : 'Wait for Approval')}</div>
          </div>
        </div>
        {isRefine && (
          <div className="text-[11px] text-zinc-500 dark:text-zinc-400 mb-1">
            Request changes loops the RCA{typeof data.max_rounds === 'number' ? ` (max ${data.max_rounds})` : ''}
          </div>
        )}
        <div className="flex justify-between mt-2 text-xs">
          <span className="text-green-600 dark:text-green-400 font-medium">Approved →</span>
          <span className="text-red-600 dark:text-red-400 font-medium">Rejected →</span>
        </div>
      </Card>
    </div>
  );
}
